$(document).ready(function() {
  const bxBreadcrumbsContainerElem = $('.breadcrumbs-container');

  bxBreadcrumbsContainerElem.css('display', 'block');

  const bxTitleWrapperElem = document.createElement('div');
  bxTitleWrapperElem.classList.add('custom-content-section');
  bxTitleWrapperElem.classList.add('bx-custom-content-section');

  $('#site-main').prepend(bxTitleWrapperElem);
  
  const bxTitleElem = $('.collection--description .collection--title');

  bxTitleElem.prependTo('.bx-custom-content-section');

  bxTitleElem.css('display', 'block');
  bxTitleElem.css('flex', '1');
  // bxTitleElem.css('margin-top', '50px');

  $('.breadcrumbs-container').append(bxTitleElem);

  $('.collection--description.rte.d_checkbox').removeAttr('id');
});
